{
	"name": "@context/source",
	"version": "1.5.4",
	"license": "MIT",
	"scripts": {
		"nx": "npx nx",
		"start": "npx nx serve",
		"build": "npx nx build",
		"deploy": "npx firebase deploy --only hosting",
		"format": "prettier --write '**/*.{json,md,ts,tsx,css,scss,html}'",
		"lint": "npx nx affected --target=lint",
		"lint:fix": "npx nx affected --target=lint --fix",
		"test": "npx nx test",
		"---- Dev ----": "",
		"start:dev": "npx firebase use dev && npx nx serve web --configuration development --port 4200",
		"build:dev": "npx nx build web --aot --configuration development",
		"deploy:dev": "npx firebase use dev && npm run build:dev && npx firebase deploy --only hosting:web",
		"start:chemicals:dev": "npx firebase use dev && npx nx serve chemicals --configuration development --port 4201",
		"build:chemicals:dev": "npx nx build chemicals --aot --configuration development",
		"deploy:chemicals:dev": "npx firebase use dev && npm run build:chemicals:dev && npx firebase deploy --only hosting:chemicals",
		"start:external:dev": "npx firebase use dev && npx nx serve external --configuration development --port 4203",
		"build:external:dev": "npx nx build external --aot --configuration development",
		"deploy:external:dev": "npx firebase use dev && npm run build:external:dev && npx firebase deploy --only hosting:external",
		"start:api:dev": "npx firebase use dev && npx nx serve api --configuration development",
		"build:api:dev": "npx nx build api --configuration development",
		"deploy:api:dev": "npx firebase use dev && npm run build:api:dev && npx firebase deploy --only functions",
		"deploy:api:env:dev": "npx firebase use dev && npm run build:api:dev && node tools/scripts/deploy-functions-env.js --env development",
		"deploy:api:rules:dev": "npx firebase use dev && npx firebase deploy --only firestore:rules",
		"deploy:storage:cors:dev": "gsutil cors set cors.json gs://dev-papyrus.appspot.com",
		"deploy:storage:rules:dev": "npx firebase use dev && npx firebase deploy --only storage",
		"deploy:indexes:dev": "npx firebase use dev && npx firebase deploy --only firestore:indexes",
		"start:scripts:dev": "npx nx serve scripts --environment=development",
		"start:admin:dev": "npx firebase use dev && npx nx serve admin --configuration development --port 4202",
		"build:admin:dev": "npx nx build admin --aot --configuration development",
		"deploy:admin:dev": "npx firebase use dev && npm run build:admin:dev && npx firebase deploy --only hosting:admin",
		"---- Prod ----": "",
		"start:prod": "npx firebase use prod && npx nx serve web --configuration production",
		"build:prod": "npx nx build web --aot --configuration production",
		"deploy:prod": "npx firebase use prod && npm run build:prod && npx firebase deploy --only hosting:web && npm run sentry:sourcemaps",
		"start:chemicals:prod": "npx firebase use prod && npx nx serve chemicals --configuration production --port 4201",
		"build:chemicals:prod": "npx nx build chemicals --aot --configuration production",
		"deploy:chemicals:prod": "npx firebase use prod && npm run build:chemicals:prod && npx firebase deploy --only hosting:chemicals",
		"start:external:prod": "npx firebase use prod && npx nx serve external --configuration production --port 4203",
		"build:external:prod": "npx nx build external --aot --configuration production",
		"deploy:external:prod": "npx firebase use prod && npm run build:external:prod && npx firebase deploy --only hosting:external",
		"start:api:prod": "npx firebase use prod && npx nx serve api --configuration production",
		"build:api:prod": "npx nx build api --configuration production",
		"deploy:api:prod": "npx firebase use prod && npm run build:api:prod && npx firebase deploy --only functions",
		"deploy:api:env:prod": "npx firebase use prod && npm run build:api:prod && node tools/scripts/deploy-functions-env.js --env production",
		"deploy:api:rules:prod": "npx firebase use prod && npx firebase deploy --only firestore:rules",
		"deploy:storage:cors:prod": "gsutil cors set cors.json gs://papyrus-6486f.appspot.com",
		"deploy:storage:rules:prod": "npx firebase use prod && npx firebase deploy --only storage",
		"deploy:indexes:prod": "npx firebase use prod && npx firebase deploy --only firestore:indexes",
		"start:scripts:prod": "npx nx serve scripts --environment=production",
		"start:admin:prod": "npx firebase use prod && npx nx serve admin --configuration production --port 4202",
		"build:admin:prod": "npx nx build admin --aot --configuration production",
		"deploy:admin:prod": "npx firebase use prod && npm run build:admin:prod && npx firebase deploy --only hosting:admin",
		"---- Local Emulators ----": "",
		"emulators": "npx nx build api && npx firebase emulators:start --project demo-context --only auth,firestore,functions,storage --import .emulator-data --export-on-exit .emulator-data",
		"emulators:fresh": "npx nx build api && npx firebase emulators:start --project demo-context --only auth,firestore,functions,storage --export-on-exit .emulator-data",
		"emulators:data": "npx firebase emulators:start --project demo-context --only auth,firestore,storage --import .emulator-data --export-on-exit .emulator-data",
		"emulators:data:fresh": "npx firebase emulators:start --project demo-context --only auth,firestore,storage --export-on-exit .emulator-data",
		"start:local": "npx nx serve web --configuration local --port 4200",
		"start:api:local": "USE_FIREBASE_EMULATORS=true npx nx serve api",
		"start:chemicals:local": "npx nx serve chemicals --configuration local --port 4201",
		"start:admin:local": "npx nx serve admin --configuration local --port 4202",
		"start:external:local": "npx nx serve external --configuration local --port 4203",
		"---- MISC ----": "",
		"nx:reset": "npx nx reset --verbose",
		"nx:report": "npx nx report --verbose",
		"version:sync": "node tools/scripts/sync-native-version.js",
		"cap:sync": "npm run version:sync && npx cap sync",
		"open:android": "npx cap open android",
		"open:ios": "npx cap open ios",
		"translations": "npx node tools/scripts/auto-order-translations.js",
		"sentry:sourcemaps": "npx sentry-cli sourcemaps inject --org vizashift --project context ./dist/apps/web/browser && sentry-cli sourcemaps upload --org vizashift --project context ./dist/apps/web/browser",
		"sentry:api:sourcemaps": "npx sentry-cli sourcemaps inject --org vizashift --project context ./apps/api/dist && sentry-cli sourcemaps upload --org vizashift --project context ./apps/api/dist",
		"prepare": "husky"
	},
	"engines": {
		"node": "22"
	},
	"private": true,
	"dependencies": {
		"@algolia/client-search": "^5.46.0",
		"@angular/animations": "21.2.9",
		"@angular/cdk": "21.2.9",
		"@angular/common": "21.2.9",
		"@angular/compiler": "21.2.9",
		"@angular/core": "21.2.9",
		"@angular/forms": "21.2.9",
		"@angular/platform-browser": "21.2.9",
		"@angular/platform-browser-dynamic": "21.2.9",
		"@angular/router": "21.2.9",
		"@angular/service-worker": "21.2.9",
		"@capacitor/android": "^8.0.0",
		"@capacitor/camera": "^8.0.0",
		"@capacitor/core": "^8.0.0",
		"@capacitor/file-transfer": "^2.0.5",
		"@capacitor/file-viewer": "^2.0.2",
		"@capacitor/filesystem": "^8.0.0",
		"@capacitor/ios": "^8.0.0",
		"@ionic/pwa-elements": "^3.3.0",
		"@jsverse/transloco": "^8.2.0",
		"@nestjs/axios": "4.0.1",
		"@nestjs/common": "^10.3.10",
		"@nestjs/core": "^10.3.10",
		"@nestjs/microservices": "^10.3.10",
		"@nestjs/platform-express": "^10.3.10",
		"@nestjs/websockets": "^10.3.10",
		"@nx/angular": "23.0.0",
		"@sendgrid/mail": "^8.1.5",
		"@sentry/angular": "^10.32.1",
		"@sentry/node": "^10.32.1",
		"@taiga-ui/addon-mobile": "5.11.0",
		"@taiga-ui/cdk": "5.11.0",
		"@taiga-ui/core": "5.11.0",
		"@taiga-ui/event-plugins": "^5.0.0",
		"@taiga-ui/i18n": "5.11.0",
		"@taiga-ui/icons": "5.11.0",
		"@taiga-ui/kit": "5.11.0",
		"@taiga-ui/layout": "5.11.0",
		"@taiga-ui/legacy": "5.11.0",
		"@taiga-ui/polymorpheus": "^5.0.0",
		"@taiga-ui/styles": "5.11.0",
		"@tinkoff/ng-polymorpheus": "^4.3.0",
		"@types/ua-parser-js": "^0.7.39",
		"algoliasearch": "^5.46.2",
		"browser-image-compression": "^2.0.2",
		"class-transformer": "^0.5.1",
		"class-validator": "^0.14.1",
		"cors": "^2.8.5",
		"dotenv": "^16.4.5",
		"firebase": "12.15.0",
		"firebase-admin": "13.9.0",
		"hammerjs": "^2.0.8",
		"jsonwebtoken": "^9.0.2",
		"mousetrap": "^1.6.5",
		"ngx-image-cropper": "^9.1.6",
		"ngx-quill": "^30.0.1",
		"nx-cloud": "19.1.3",
		"quill": "^2.0.3",
		"reflect-metadata": "^0.1.13",
		"rxjs": "^7.8.1",
		"string-format": "^2.0.0",
		"tslib": "^2.3.0",
		"ua-parser-js": "^1.0.38"
	},
	"devDependencies": {
		"@angular-devkit/build-angular": "21.2.9",
		"@angular-devkit/core": "21.2.9",
		"@angular-devkit/schematics": "21.2.9",
		"@angular-eslint/eslint-plugin": "21.4.0",
		"@angular-eslint/eslint-plugin-template": "21.4.0",
		"@angular-eslint/template-parser": "21.4.0",
		"@angular/cli": "21.2.16",
		"@angular/compiler-cli": "21.2.9",
		"@angular/language-service": "21.2.9",
		"@angular/pwa": "21.2.9",
		"@capacitor/assets": "^3.0.5",
		"@capacitor/cli": "^8.0.0",
		"@eslint/eslintrc": "3.3.1",
		"@eslint/js": "9.39.1",
		"@nestjs/schematics": "11.0.9",
		"@nestjs/testing": "^10.3.10",
		"@nx/devkit": "23.0.0",
		"@nx/esbuild": "23.0.0",
		"@nx/eslint": "23.0.0",
		"@nx/eslint-plugin": "23.0.0",
		"@nx/jest": "23.0.0",
		"@nx/js": "23.0.0",
		"@nx/nest": "23.0.0",
		"@nx/node": "23.0.0",
		"@nx/playwright": "23.0.0",
		"@nx/web": "23.0.0",
		"@nx/webpack": "23.0.0",
		"@nx/workspace": "23.0.0",
		"@playwright/test": "^1.36.0",
		"@schematics/angular": "21.2.9",
		"@sentry/cli": "^3.0.3",
		"@swc-node/register": "1.11.1",
		"@swc/core": "1.15.8",
		"@swc/helpers": "0.5.23",
		"@tailwindcss/postcss": "^4.1.17",
		"@types/cors": "^2.8.17",
		"@types/express": "^4.17.21",
		"@types/jest": "30.0.0",
		"@types/jsonwebtoken": "^9.0.6",
		"@types/mousetrap": "^1.6.15",
		"@types/node": "^22.0.0",
		"@types/string-format": "^2.0.3",
		"@typescript-eslint/eslint-plugin": "8.46.3",
		"@typescript-eslint/parser": "8.46.3",
		"@typescript-eslint/utils": "8.46.3",
		"angular-eslint": "21.4.0",
		"esbuild": "^0.19.2",
		"eslint": "9.39.1",
		"eslint-config-prettier": "10.1.8",
		"eslint-plugin-playwright": "2.3.0",
		"firebase-functions": "^7.2.5",
		"firebase-functions-test": "3.5.0",
		"firebase-tools": "15.22.0",
		"husky": "^9.1.7",
		"jest": "30.3.0",
		"jest-environment-jsdom": "30.2.0",
		"jest-environment-node": "^29.7.0",
		"jest-preset-angular": "16.0.0",
		"jest-util": "30.2.0",
		"lint-staged": "^16.2.6",
		"nx": "23.0.0",
		"postcss": "^8.5.6",
		"prettier": "^3.7.4",
		"tailwindcss": "^4.1.17",
		"ts-jest": "29.4.5",
		"ts-node": "10.9.1",
		"typescript": "5.9.3",
		"typescript-eslint": "8.46.3",
		"webpack": "5.107.2",
		"webpack-cli": "7.0.3",
		"webpack-dev-server": "5.2.5",
		"zone.js": "^0.15.1"
	}
}
